/**
 * `navVersion`: FNV-1a 32-bit hash over the canonical walk data
 * (w and h as little-endian uint16, then one byte per cell). Synchronous and
 * dependency-free so it runs identically in Node and the browser. Hashes the
 * decoded cells, not the base64 text, so equivalent encodings agree.
 */
export function computeNavVersion(w, h, cells) {
    let hash = 0x811c9dc5;
    const step = (b) => {
        hash ^= b & 0xff;
        hash = Math.imul(hash, 0x01000193) >>> 0;
    };
    step(w);
    step(w >>> 8);
    step(h);
    step(h >>> 8);
    for (let i = 0; i < cells.length; i++)
        step(cells[i]);
    return hash >>> 0;
}
